import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import p from "./iconfont.es5471.js";
const h = {
  display: "block"
}, s = ({ size: e = 16, useVw: c, useRem: l, color: n, withColor: o, removeClassName: t, disableSSR: m, style: i, ...d }) => {
  const u = i ? { ...h, ...i } : h;
  return /* @__PURE__ */ a.createElement(p, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-quanqiuzuoshishangjihua", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), height: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: u, fill: "none", ...d }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-å¨çåå¸åè®¡å"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        clipRule: "evenodd",
        fillRule: "evenodd",
        fill: o ? r(n, 0, "#262933") : "#262933",
        datafollowfill: o ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.939 3.55a12.051 12.051 0 0 0-.311-.003c-6.515 0-11.8 5.268-11.827 11.777a.912.912 0 0 0-.002.051c0 6.533 5.296 11.829 11.829 11.829v-.043c.149.028.3.043.455.043.88 0 1.68-.482 2.331-1.112.667-.644 1.28-1.538 1.8-2.59.943-1.905 1.634-4.432 1.758-7.227h4.584a.9.9 0 0 0 .9-.9c0-6.245-4.84-11.36-10.974-11.798a2.646 2.646 0 0 0-.543-.026ZM11.84 25.012c-3.905-1.128-6.83-4.564-7.2-8.736h4.554c.124 2.795.815 5.322 1.758 7.227.272.55.57 1.058.888 1.51Zm-7.2-10.536h4.553c.118-2.787.774-5.313 1.7-7.22.264-.543.553-1.044.865-1.491-3.863 1.152-6.75 4.57-7.118 8.711Zm7.925 8.229c-.818-1.654-1.446-3.906-1.569-6.429h8.174c-.123 2.523-.75 4.775-1.569 6.429-.458.925-.96 1.632-1.438 2.094-.492.476-.866.606-1.08.606-.214 0-.587-.13-1.08-.606-.478-.462-.98-1.169-1.438-2.094Zm-1.57-8.229h8.176c-.117-2.53-.716-4.783-1.517-6.434-.449-.924-.945-1.626-1.425-2.084-.387-.37-.716-.538-.967-.59-.092-.006-.184-.01-.277-.014-.26.032-.617.192-1.048.604-.48.458-.976 1.16-1.424 2.084-.802 1.65-1.401 3.904-1.518 6.434Zm13.621 0h-3.643c-.118-2.787-.774-5.313-1.7-7.22-.18-.37-.37-.72-.573-1.047a10.035 10.035 0 0 1 5.916 8.267Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M21.609 21.142a2.55 2.55 0 0 0 0 3.606l1.442 1.443a2.55 2.55 0 0 0 3.606 0l1.442-1.443a2.55 2.55 0 0 0 0-3.606L26.657 19.7a2.55 2.55 0 0 0-3.606 0l-1.442 1.442Zm1.202 2.404a.85.85 0 0 1 0-1.201l1.442-1.443a.85.85 0 0 1 1.202 0l1.442 1.442a.85.85 0 0 1 0 1.202l-1.442 1.443a.85.85 0 0 1-1.202 0l-1.442-1.443Z"
        }
      )
    )
  )));
}, E = s;
export {
  E as default
};
